import Vue from 'vue'
import Vuex from 'vuex'
import deviceData from './modules/deviceData'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    socketAction: '' // socket接受消息数据
  },
  getters: {
  },
  mutations: {
    // socket 接受消息数据
    setSocketAction (state, data) {
      state.socketAction = data
    }
  },
  actions: {
  },
  modules: {
    deviceData
  }
})
